export default "__VITE_ASSET__DgN5Bw65__"